import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { AlternativeResolutionComponent } from './alternative-resolution/alternative-resolution.component';
import { ManageDataComponent } from './manage-data/manage-data.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { AgentGuard } from 'src/app/guards/agent.guard';

const routes: Routes = [
  {
    path: '', loadChildren: () => import('./home/home.module').then(m => m.HomeModule), data: { animation: 'HomePage' }
  },
  //Properties
  {
    path: 'properties', loadChildren: () => import('./properties/properties.module').then(m => m.PropertiesModule), data: { animation: 'Properties' }
  },
  {
    path: 'imoveis', loadChildren: () => import('./properties/properties.module').then(m => m.PropertiesModule), data: { animation: 'Properties' }
  },
  {
    path: 'proprietes', loadChildren: () => import('./properties/properties.module').then(m => m.PropertiesModule), data: { animation: 'Properties' }
  },
  {
    path: 'propiedades', loadChildren: () => import('./properties/properties.module').then(m => m.PropertiesModule), data: { animation: 'Properties' }
  },
  {
    path: 'immobilien', loadChildren: () => import('./properties/properties.module').then(m => m.PropertiesModule), data: { animation: 'Properties' }
  },

  //Enterprises
  {
    path: 'enterprises', loadChildren: () => import('./enterprises/enterprises.module').then(m => m.EnterprisesModule), data: { animation: 'Enterprises' }
  },
  {
    path: 'empreendimentos', loadChildren: () => import('./enterprises/enterprises.module').then(m => m.EnterprisesModule), data: { animation: 'Enterprises' }
  },
  {
    path: 'empresas', loadChildren: () => import('./enterprises/enterprises.module').then(m => m.EnterprisesModule), data: { animation: 'Enterprises' }
  },
  {
    path: 'entreprises', loadChildren: () => import('./enterprises/enterprises.module').then(m => m.EnterprisesModule), data: { animation: 'Enterprises' }
  },
  {
    path: 'developments', loadChildren: () => import('./enterprises/enterprises.module').then(m => m.EnterprisesModule), data: { animation: 'Enterprises' }
  },

  //Property
  {
    path: 'property/:name/:id', loadChildren: () => import('./property/property.module').then(m => m.PropertyModule), data: { animation: 'Property' }
  },
  {
    path: 'imovel/:name/:id', loadChildren: () => import('./property/property.module').then(m => m.PropertyModule), data: { animation: 'Property' }
  },
  {
    path: 'propriete/:name/:id', loadChildren: () => import('./property/property.module').then(m => m.PropertyModule), data: { animation: 'Property' }
  },
  {
    path: 'propiedad/:name/:id', loadChildren: () => import('./property/property.module').then(m => m.PropertyModule), data: { animation: 'Property' }
  },
  {
    path: 'immobilie/:name/:id', loadChildren: () => import('./property/property.module').then(m => m.PropertyModule), data: { animation: 'Property' }
  },

  //Contacts
  {
    path: 'contacts', loadChildren: () => import('./contact-us/contact-us.module').then(m => m.ContactsUsModule), data: { animation: 'Contacts' }
  },
  {
    path: 'contactos', loadChildren: () => import('./contact-us/contact-us.module').then(m => m.ContactsUsModule), data: { animation: 'Contacts' }
  },
  {
    path: 'kontakte', loadChildren: () => import('./contact-us/contact-us.module').then(m => m.ContactsUsModule), data: { animation: 'Contacts' }
  },
  {
    path: 'contacts', loadChildren: () => import('./contact-us/contact-us.module').then(m => m.ContactsUsModule), data: { animation: 'Contacts' }
  },

  //Sell Properties
  {
    path: 'sell-properties', loadChildren: () => import('./sell-properties/sell-properties.module').then(m => m.SellPropertiesModule), data: { animation: 'SellProperties' }
  },
  {
    path: 'vender-imoveis', loadChildren: () => import('./sell-properties/sell-properties.module').then(m => m.SellPropertiesModule), data: { animation: 'SellProperties' }
  },
  {
    path: 'vendre', loadChildren: () => import('./sell-properties/sell-properties.module').then(m => m.SellPropertiesModule), data: { animation: 'SellProperties' }
  },
  {
    path: 'vender', loadChildren: () => import('./sell-properties/sell-properties.module').then(m => m.SellPropertiesModule), data: { animation: 'SellProperties' }
  },
  {
    path: 'verkaufen', loadChildren: () => import('./sell-properties/sell-properties.module').then(m => m.SellPropertiesModule), data: { animation: 'SellProperties' }
  },

  //About Us
  {
    path: 'about-us', loadChildren: () => import('./about-us/about-us.module').then(m => m.AboutUsModule), data: { animation: 'AboutUs' }
  },
  {
    path: 'sobre-nos', loadChildren: () => import('./about-us/about-us.module').then(m => m.AboutUsModule), data: { animation: 'AboutUs' }
  },
  {
    path: 'uber-uns', loadChildren: () => import('./about-us/about-us.module').then(m => m.AboutUsModule), data: { animation: 'AboutUs' }
  },
  {
    path: 'sobre-nosotros', loadChildren: () => import('./about-us/about-us.module').then(m => m.AboutUsModule), data: { animation: 'AboutUs' }
  },
  {
    path: 'a-propos-de-nous', loadChildren: () => import('./about-us/about-us.module').then(m => m.AboutUsModule), data: { animation: 'AboutUs' }
  },

  //Saved Properties
  {
    path: 'saved-properties', loadChildren: () => import('./saved-properties/saved-properties.module').then(m => m.SavedPropertiesModule), data: { animation: 'SavedProperties' }
  },
  {
    path: 'guardados', loadChildren: () => import('./saved-properties/saved-properties.module').then(m => m.SavedPropertiesModule), data: { animation: 'SavedProperties' }
  },
  {
    path: 'enregistre', loadChildren: () => import('./saved-properties/saved-properties.module').then(m => m.SavedPropertiesModule), data: { animation: 'SavedProperties' }
  },
  {
    path: 'gespeichert', loadChildren: () => import('./saved-properties/saved-properties.module').then(m => m.SavedPropertiesModule), data: { animation: 'SavedProperties' }
  },

  //Alternative Resolution
  {
    path: 'alternative-resolution', component: AlternativeResolutionComponent, data: { animation: 'AlternativeResolution' }
  },
  {
    path: 'resolucao-de-litigios', component: AlternativeResolutionComponent, data: { animation: 'AlternativeResolution' }
  },
  {
    path: 'alternative-streitbeilegung', component: AlternativeResolutionComponent, data: { animation: 'AlternativeResolution' }
  },
  {
    path: 'resolucion-alternativa-de-disputas', component: AlternativeResolutionComponent, data: { animation: 'AlternativeResolution' }
  },
  {
    path: 'resolution-alternative-des-litiges', component: AlternativeResolutionComponent, data: { animation: 'AlternativeResolution' }
  },

  //Terms and Conditions
  {
    path: 'terms-conditions', component: TermsConditionsComponent, data: { animation: 'TermsConditions' }
  },
  {
    path: 'termos-e-condicoes', component: TermsConditionsComponent, data: { animation: 'TermsConditions' }
  },
  {
    path: 'conditions-generales', component: TermsConditionsComponent, data: { animation: 'TermsConditions' }
  },
  {
    path: 'terminos-y-condiciones', component: TermsConditionsComponent, data: { animation: 'TermsConditions' }
  },
  {
    path: 'allgemeine-geschaftsbedingungen', component: TermsConditionsComponent, data: { animation: 'TermsConditions' }
  },

  //Privacy Policy
  {
    path: 'privacy-policy', component: PrivacyPolicyComponent, data: { animation: 'PrivacyPolicy' }
  },
  {
    path: 'politica-de-privacidade', component: PrivacyPolicyComponent, data: { animation: 'PrivacyPolicy' }
  },
  {
    path: 'datenschutz-bestimmungen', component: PrivacyPolicyComponent, data: { animation: 'PrivacyPolicy' }
  },
  {
    path: 'politica-de-privacidad', component: PrivacyPolicyComponent, data: { animation: 'PrivacyPolicy' }
  },
  {
    path: 'politique-de-confidentialite', component: PrivacyPolicyComponent, data: { animation: 'PrivacyPolicy' }
  },

  //Manage Data
  {
    path: 'manage-data', component: ManageDataComponent, data: { animation: 'ManageData' }
  },
  {
    path: 'gerir-dados', component: ManageDataComponent, data: { animation: 'ManageData' }
  },
  {
    path: 'gerer-les-donnees', component: ManageDataComponent, data: { animation: 'ManageData' }
  },
  {
    path: 'administrar-datos', component: ManageDataComponent, data: { animation: 'ManageData' }
  },
  {
    path: 'daten-verwalten', component: ManageDataComponent, data: { animation: 'ManageData' }
  },

  //Account
  {
    path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'minha-conta', loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'konto', loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'cuenta', loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'compte', loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'agent-area', loadChildren: () => import('./agent-area/agent-area.module').then(m => m.AgentAreaModule), canActivate: [AgentGuard]
  },
  // Chat
  {
    path: 'chat', loadChildren: () => import('./chat/chat.module').then(m => m.ChatModule), canActivate: [AuthGuard]
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
